import { useTranslation } from 'react-i18next';
import { withStyles } from 'vopay';
import UsersList from '@/components/Users/UsersList';
import styles from './PartnerPortalUsersTab.module.scss';

const cn = withStyles(styles);

type PartnerPortalUsersTabProps = {
  partnerAccountID: string;
};

/**
 * The partner page's Partner Portal Users tab: the partner portal's own User
 * Management page, scoped to this partner account, under the Partner Portal Users heading.
 */
export default function PartnerPortalUsersTab({ partnerAccountID }: PartnerPortalUsersTabProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'Partners.PartnerManagement.PartnerDetailsPage.Tabs' });

  return (
    <div className={cn('tab')}>
      <UsersList
        partnerAccountID={partnerAccountID}
        title={t('partnerPortalUsers', { defaultValue: 'Partner Portal Users' })}
        titleLevel="3"
      />
    </div>
  );
}
